import { create } from "zustand";

export type SortKey = "name" | "host" | "model" | "firmware" | "channels" | "online";
export type SortDir = "asc" | "desc";

interface DevicesTableState {
  sortKey: SortKey;
  sortDir: SortDir;
  setSort: (key: SortKey) => void;
}

// Estado de orden de la tabla de Dispositivos. A proposito SIN persist: el
// criterio elegido se mantiene al navegar a otra pagina y volver (el store
// vive en memoria mientras la SPA esta cargada) pero se resetea a Nombre A-Z
// al recargar el navegador.
export const useDevicesTableStore = create<DevicesTableState>()((set) => ({
  sortKey: "name",
  sortDir: "asc",
  setSort: (key) =>
    set((s) => ({
      sortKey: key,
      sortDir: s.sortKey === key ? (s.sortDir === "asc" ? "desc" : "asc") : "asc",
    })),
}));
